<template>
  <div class="container main-container p-4">
    <img src="@/assets/img/branding/logo.png" alt="Payjoy logo" />
    <div class="progress my-4">
      <div
        class="progress-bar progress-bar-color"
        role="progressbar"
        :style="{ width: progress + '%' }"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
    <h4 class="main-message">{{ mainMessage }}</h4>
    <p>{{ secondaryMessage }}</p>
  </div>
</template>
<script setup lang="ts">
defineProps({
  mainMessage: { String, required: true },
  secondaryMessage: { String, required: true },
  progress: { type: Number, required: true },
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.main-container {
  text-align: center;
}
.main-message {
  color: $pj-color-yellow-green;
}
.progress-bar-color {
  background-color: $pj-color-yellow-green;
}
</style>
